import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import {
  CIRCUIT_OPEN_EVENT,
  CIRCUIT_CLOSE_EVENT,
  isCircuitOpen,
} from '@/services/http/circuitBreaker';

/**
 * App-wide banner shown while the HTTP circuit breaker is tripped (LIL-331).
 * The breaker opens after several consecutive backend failures and pauses all
 * polling; this tells the user why the app went quiet. It clears itself the
 * moment the breaker closes (cooldown elapsed or a request succeeds).
 */
export function ServiceUnavailableBanner() {
  const [open, setOpen] = useState(isCircuitOpen);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);
    window.addEventListener(CIRCUIT_OPEN_EVENT, onOpen);
    window.addEventListener(CIRCUIT_CLOSE_EVENT, onClose);
    return () => {
      window.removeEventListener(CIRCUIT_OPEN_EVENT, onOpen);
      window.removeEventListener(CIRCUIT_CLOSE_EVENT, onClose);
    };
  }, []);

  if (!open) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-white shadow-md"
    >
      <WifiOff className="size-4 shrink-0" />
      <span>We&apos;re having trouble reaching the server. Reconnecting&hellip;</span>
    </div>
  );
}
